import {useTranslation} from 'react-i18next'

interface TutorialCardProps {
 title: string
 description: string
 duration: string
 url: string
 type: 'video' | 'image' | 'pdf'
}

export default function TutorialCard({
 title,
 description,
 duration,
 url,
 type,
}: TutorialCardProps) {
 const {t} = useTranslation()
 const openLink = () => {
  window.open(url, '_blank')
 }

 const isPdf = type === 'pdf'
 const imgCheck = type === 'image'

 const truncatedDescription =
  description?.length > 90
   ? description.slice(0, 90) + '...'
   : description

 return (
  <div
   onClick={openLink}
   className='group bg-white rounded-xl border border-[#E6EBF0] p-4 cursor-pointer hover:shadow-md transition flex flex-col h-full'
  >
   <div className='relative h-[150px] rounded-lg overflow-hidden bg-[#1E4F7A] flex items-center justify-center text-center px-4'>
    <h2 className='text-white text-lg font-semibold leading-snug line-clamp-2'>
     {title}
    </h2>

    <div className='absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 bg-black/30 transition'>
     {isPdf ? (
      <button className='bg-white text-[#4E83E4] px-4 py-1 rounded-md font-medium shadow'>
       {t('tutorials.readNow')}
      </button>
     ) : imgCheck ? (
      <button className='bg-white text-[#4E83E4] px-4 py-1 rounded-md font-medium shadow'>
       {t('tutorials.viewImg')}
      </button>
     ) : (
      <div className='bg-white w-12 h-12 rounded-full flex items-center justify-center text-black text-lg'>
       ▶
      </div>
     )}
    </div>
   </div>

   <div className='mt-4 flex flex-col flex-grow'>
    <div className='text-xs text-[#7E8B96] mb-1'>
     {imgCheck
      ? t('tutorials.image')
      : `${duration} ${
         isPdf ? t('tutorials.read') : t('tutorials.watch')
        }`}
    </div>

    <h3 className='font-semibold text-[#2D3339] text-sm line-clamp-2'>
     {title}
    </h3>
    <p className='text-xs text-[#7E8B96] mt-1 line-clamp-2'>
     {truncatedDescription}
    </p>
   </div>
  </div>
 )
}
